require('./vendor');

const context = require.context('./', true, /\.js/i);
context.keys().forEach(context);